import React, { useState, useContext, useRef } from 'react'
import { UserContext } from '../Contexts/UserContext';
import OutsideClick from './OutsideClick';
import { Link, useHistory, useLocation } from 'react-router-dom';
import logo from '../images/logo.png'
import guest from '../images/guest.png'
import { axiosUrl } from '../axiosConfig'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEllipsisH } from '@fortawesome/free-solid-svg-icons/faEllipsisH';


export default function OffCanvas() {
    const [user] = useContext(UserContext);
    const ref = useRef();   //clicking outside closes modal
    let history = useHistory()

    const [offCanvas, setOffCanvas] = useState(false)
    const offCanvasToggle = () => setOffCanvas(!offCanvas)

    let icon = `https://avatars.dicebear.com/api/gridy/${user.username}.svg`;

    OutsideClick(ref, () => {
        setOffCanvas(false);

    });

    let location = useLocation();    //for current location
    let path = location.pathname;

    const Menu = () => {
        return <div className="offcanvas-wrapper " >
            <div className="text offcanvas">


                <div className="d-flex justify-content-end view">
                    <button className="" onClick={offCanvasToggle}>
                        <svg viewBox="0 0 24 24" className="back-button ">
                            <g>
                                <path d="M13.414 12l5.793-5.793c.39-.39.39-1.023 0-1.414s-1.023-.39-1.414 0L12 10.586 6.207 4.793c-.39-.39-1.023-.39-1.414 0s-.39 1.023 0 1.414L10.586 12l-5.793 5.793c-.39.39-.39 1.023 0 1.414.195.195.45.293.707.293s.512-.098.707-.293L12 13.414l5.793 5.793c.195.195.45.293.707.293s.512-.098.707-.293c.39-.39.39-1.023 0-1.414L13.414 12z">
                                </path>
                            </g>
                        </svg>
                    </button>
                </div>

                <Link className=" nav-logo  " to="/home">
                    <img src={logo} alt='logo test' className="logo" />

                </Link >

                {!user.loggedin === true ?
                    <Link to="/explore" className={path === '/explore' ? "d-flex phone-header-link-active" : "d-flex phone-header-link "}>
                        <div className=" d-flex  ">
                            <div>
                                <svg viewBox="0 0 26 26" className="icon mr-2">
                                    <g>
                                        <path d="M22.06 19.94l-3.73-3.73C19.38 14.737 20 12.942 20 11c0-4.97-4.03-9-9-9s-9 4.03-9 9 4.03 9 9 9c1.943 0 3.738-.622 5.21-1.67l3.73 3.73c.292.294.676.44 1.06.44s.768-.146 1.06-.44c.586-.585.586-1.535 0-2.12zM11 17c-3.308 0-6-2.692-6-6s2.692-6 6-6 6 2.692 6 6-2.692 6-6 6z"></path>
                                    </g>
                                </svg>
                            </div>
                            <p className=" " style={{ fontWeight: 700 }}>Explore</p>
                        </div>
                    </Link>
                    : null}

                {!user.loggedin === true ?
                    <Link to="/more" className={path === '/more' ? "d-flex phone-header-link-active more" : "d-flex phone-header-link more"}>
                        <div className=" d-flex ">
                            <div>
                                <svg viewBox="0 0 26 26" className="icon mr-2">
                                    <g>
                                        <circle cx="17" cy="12" r="1.5"></circle>
                                        <circle cx="12" cy="12" r="1.5"></circle>
                                        <circle cx="7" cy="12" r="1.5"></circle>
                                        <path d="M12 22.75C6.072 22.75 1.25 17.928 1.25 12S6.072 1.25 12 1.25 22.75 6.072 22.75 12 17.928 22.75 12 22.75zm0-20C6.9 2.75 2.75 6.9 2.75 12S6.9 21.25 12 21.25s9.25-4.15 9.25-9.25S17.1 2.75 12 2.75z"></path>
                                    </g>

                                </svg>
                            </div>
                            <p className=" "
                                style={{ fontWeight: 700 }}
                            >
                                More
                            </p>
                        </div>
                    </Link>
                    : null}

                {user.loggedin ? <div className=" mt-2" style={{ fontSize: '16px' }}>
                    <img src={icon} alt='logo test' className="logo mt-2" />

                    <div>{user.fullname}</div>
                    <span>@{user.username}</span>
                </div>
                    :
                    null
                }

                {user.loggedin ?
                    <div className="offcanvas-button mr-1 " style={{ fontSize: '14px' }}>
                        <button
                            className="text p-2 btn-accent rounded"
                            type="submit"
                            onClick={Logout}
                        >
                            Log out @{user.username}
                        </button>
                    </div >
                    :
                    <div className="offcanvas-button d-flex">
                        <button
                            className=" btn login-submit rounded-pill btn-accent w-50"
                            type="submit"
                            onClick={Login}
                        >
                            Log In
                        </button>

                        <button
                            className="btn login-submit rounded-pill btn-accent-outline w-50"
                            type="submit"
                            onClick={Signup}
                        >
                            SignUp
                        </button>
                    </div >
                }
            </div>
        </div>
    }

    const Logout = () => {
        axiosUrl.post("/logout")
            .then(() => {
                history.push("/");
            });
    };

    const Login = () => {
        return history.push("/")
    }

    const Signup = () => {
        return history.push("/signup")

    }


    return (
        <div className="just-mobile">
            <div ref={ref}>
                <FontAwesomeIcon icon={faEllipsisH} size="lg" onClick={() => offCanvasToggle()} />
            </div>
            {offCanvas ? <Menu /> : null}
        </div>
    )
}
